import { DialogPanel, DialogPanelProps } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import { PrettyMerge } from '../../lib/tsUtilityTypes';

type StyledDialogPanelProps = PrettyMerge<DialogPanelProps, { className?: string }>;
export const StyledDialogPanel: React.FC<StyledDialogPanelProps> = ({ className, ...props }) => {
  return (
    <DialogPanel
      {...props}
      className={twMerge(
        'relative flex w-[350px] flex-col gap-3 overflow-hidden rounded-lg bg-backgroundPrimary p-4',
        className
      )}
    />
  );
};
